import { useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Profile from './pages/Dashboard/Profile/Profile';
import Employees from './pages/Dashboard/Employees/Employees';
import EmployeeCreate from './pages/Dashboard/Employees/EmployeeCreate/EmployeeCreate';
import EmployeeDetails from './pages/Dashboard/Employees/EmployeeDetails/EmployeeDetails';
import Tickets from './pages/Dashboard/Tickets/Tickets';
import TicketDetails from './pages/Dashboard/Tickets/TicketDetails/TicketDetails';
import Requirements from './pages/Dashboard/Requirements/Requirements';
import RequirementDetails from './pages/Dashboard/Requirements/RequirementDetails/RequirementDetails';
import Visits from './pages/Dashboard/Visits/Visits';

const Router = () => {
  const token = useSelector(state => state.auth.token);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={token ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/dashboard/*" element={token ? <Dashboard /> : <Navigate to="/login" />}>
          <Route index element={<Navigate to="empleados" />} />
          <Route path="perfil" element={<Profile />} />
          <Route path="empleados" element={<Employees />} />

          <Route path="requirements" element={<Requirements />} />
          <Route path="requirements/:id" element={<RequirementDetails />} />

          <Route path="visits" element={<Visits />} />

          <Route path="empleados/cargar" element={<EmployeeCreate />} />
          <Route path="empleados/:id" element={<EmployeeDetails />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="tickets/:id" element={<TicketDetails />} />
          <Route path="*" element={<Navigate to="" />} />
        </Route>
        <Route path="*" element={token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
